module.exports = __webpack_public_path__ + "img/tu5.512efab0.png";